import { css } from '@emotion/css'

export const fractalLogo = css`
  align-self: center;
  margin: 1em 0;
  max-width: 20em;
`

export const responsive = css`
  max-width: 100%;
  height: auto;
`
